import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import type {createPropertyAmenityApi} from "../api/create-property-amenity-api";
import type {PropertyAmenity} from "../types";

type PropertyAmenityApi = ReturnType<typeof createPropertyAmenityApi>;

export function createPropertyAmenityService(api: PropertyAmenityApi) {
  return {
    async getPropertyAmenities(options: ParamsOptions): Promise<GetListResponse<PropertyAmenity>> {
      const {data} = await api.search(options);
      const raw = data as {
        data?: PropertyAmenity[];
        meta?: {total: number; from?: number; to?: number};
      };
      const items = Array.isArray(raw.data) ? raw.data : [];
      const meta = raw.meta ?? {total: 0};
      return {
        data: items,
        meta: {
          total: meta.total,
          from: meta.from ?? 0,
          to: meta.to ?? 0,
        },
      };
    },

    async getPropertyAmenity(id: number): Promise<PropertyAmenity | undefined> {
      const {data} = await api.getById(id);
      return data.data;
    },

    async createPropertyAmenity(
      payload: Record<string, unknown>,
    ): Promise<PropertyAmenity | undefined> {
      const {data} = await api.create(payload);
      return data.data;
    },

    async updatePropertyAmenity(
      id: number,
      payload: Record<string, unknown>,
    ): Promise<PropertyAmenity | undefined> {
      const {data} = await api.update(id, payload);
      return data.data;
    },

    async deletePropertyAmenity(id: number): Promise<void> {
      await api.delete(id);
    },
  };
}

export type PropertyAmenityService = ReturnType<typeof createPropertyAmenityService>;
